import SwiperCore, {A11y, Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useEffect, useState} from 'react';
import BannerService from '../../services/banner.service';
import styles from './SlideHome.module.css';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
import ConfigService from '@services/config.service';

export default function SlideHome() {
    const {locale, push} = useRouter();
    const [bannerHomeSlide, setBannerHomeSlide] = useState([]);
    const bannerService = new BannerService();
    const [activeIndex, setActiveIndex] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [blurBoxStatus, setBlurBoxStatus] = useState(false);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await bannerService.getBannerByKey({keys: 'HOME_TOP'});
                setBannerHomeSlide(response);
            } catch (error) {
                console.error('Failed to fetch banners:', error);
            }
        };
        const fetchStatus = async () => {
            const configService = new ConfigService();
            try {
                const status = await configService.postAppConfig('WEB_NUM_HOSPITAL_BLUR_BOX_STATUS');
                setBlurBoxStatus(status?.WEB_NUM_HOSPITAL_BLUR_BOX_STATUS === '1');
            } catch (error) {
                console.error('Failed to fetch status:', error);
            }
        };
        fetchBanners();
        fetchStatus();
    }, []);

    const swiperConfig = {
        spaceBetween: 30,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: `.${styles['swiper-pagination']}`,
            clickable: true,
        },
    };

    const handleSearchSubmit = e => {
        e.preventDefault();
        if (searchValue.trim()) {
            push({
                pathname: '/tim-kiem',
                query: {
                    filterType: activeIndex,
                    filterValue: searchValue,
                },
            });
        }
    };

    return (
        <>
            <div className={styles['container']}>
                <div className={styles['swiper-container']}>
                    <Swiper {...swiperConfig} className={styles['swiper']}>
                        {bannerHomeSlide &&
                            bannerHomeSlide.length > 0 &&
                            bannerHomeSlide.map((banner, index) => (
                                <SwiperSlide key={index}>
                                    <section className="hero" aria-label={banner.title || 'TNH Hospital Group'}>
                                        <img
                                            className="hero__bg"
                                            src={banner.picture_url}
                                            alt={banner.title || banner.description || 'TNH Hospital Group'}
                                        />
                                    </section>
                                </SwiperSlide>
                            ))}
                    </Swiper>
                    <div className={styles['swiper-pagination']}></div>
                </div>
                <section className="hero hero2">
                    <div className="container">
                        {blurBoxStatus && (
                            <div className="hero__card">
                                <span className="hero__eyebrow">
                                    {getLocaleContent(locale, 'page.slide-home.container')}
                                </span>

                                <h1 className="hero__title">
                                    <span>{getLocaleContent(locale, 'page.slide-home.title1')}</span>
                                    <span className="hero__accent">
                                        {getLocaleContent(locale, 'page.slide-home.title2')}
                                        <svg
                                            className="hero__underline"
                                            viewBox="0 0 259 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 9.44392C30.15 4.8134 68.5668 2 110.666 2C175.047 2 230.814 8.57922 258 18.1748"
                                                stroke="#FFB74D"
                                                strokeWidth="2.6958"
                                            />
                                        </svg>
                                    </span>
                                </h1>

                                <h2 className="hero__title hero__title--sub">
                                    {getLocaleContent(locale, 'page.slide-home.title3')}
                                </h2>

                                <p className="hero__lead">{getLocaleContent(locale, 'page.slide-home.description')}</p>

                                <a className="hero__cta" href="#dv-dat-lich">
                                    <img className="icon" src="/bw_image/ic_calendar.svg" alt="" />
                                    {getLocaleContent(locale, 'common.booking')}
                                </a>
                            </div>
                        )}
                    </div>
                    <div className="hero__actions">
                        <div className="hero__tabs">
                            <button
                                className={`${styles['pill']}${activeIndex === 0 ? ` ${styles['is-active']}` : ''}`}
                                onClick={() => setActiveIndex(0)}>
                                {getLocaleContent(locale, 'common.all')}
                            </button>
                            <button
                                className={`${styles['pill']}${activeIndex === 1 ? ` ${styles['is-active']}` : ''}`}
                                onClick={() => setActiveIndex(1)}>
                                {getLocaleContent(locale, 'page.slide-home.doctor')}
                            </button>
                            <button
                                className={`${styles['pill']}${activeIndex === 2 ? ` ${styles['is-active']}` : ''}`}
                                onClick={() => setActiveIndex(2)}>
                                {getLocaleContent(locale, 'page.slide-home.service')}
                            </button>
                            <button
                                className={`${styles['pill']}${activeIndex === 3 ? ` ${styles['is-active']}` : ''}`}
                                onClick={() => setActiveIndex(3)}>
                                {getLocaleContent(locale, 'page.slide-home.department')}
                            </button>
                        </div>

                        <form className="hero__search" role="search" onSubmit={handleSearchSubmit}>
                            <input
                                className="hero__input"
                                type="search"
                                value={searchValue}
                                onChange={e => setSearchValue(e.target.value)}
                                placeholder={getLocaleContent(locale, 'common.search-label')}
                                aria-label={getLocaleContent(locale, 'common.search-label')}
                            />
                            <button className="hero__btn" aria-label="Tìm" type="submit">
                                <img className="icon" src="/bw_image/ic_search.svg" alt="" />
                            </button>
                        </form>
                    </div>
                </section>
            </div>
        </>
    );
}
